const TeamManager = () => import('@/components/Team/TeamManager')

export default [
  {
    path: '/Manage/Team/:id',
    name: 'manage-team',
    component: TeamManager
  }
]
